import React from 'react';
import {
  SingleColumnLayout,
  PageTitle,
  ContentContainer,
  SingleColumnLayoutContentWrapper,
} from '@flow/components/ui';
import { FormattedMessage } from 'react-intl';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-static';
import { RouteComponentProps } from 'react-router';
import BasicButton from '@flow/components/ui/button/BasicButton';

interface Props {
  appLanguage: IAppLanguage;
  _setLanguage: any;
}

interface State {

}

class Page404 extends React.Component<Props & RouteComponentProps<{}>, State> {
  componentWillMount() {
    const { _setLanguage } = this.props;
    const appLanguage = this._resolveAppLangFromUrl();
    _setLanguage({ appLanguage, lang_versions: null });
  }

  componentWillReceiveProps() {
    const { _setLanguage, } = this.props;
    const appLanguage = this._resolveAppLangFromUrl();
    _setLanguage({ appLanguage, lang_versions: null });
  }

  render() {
    const appLang = this._resolveAppLangFromUrl();

    return (
      <SingleColumnLayout>
        <PageTitle>
          <FormattedMessage id={'404.title'}/>
        </PageTitle>
        <SingleColumnLayoutContentWrapper>
          <ContentContainer>
            <h4 style={{marginBottom: '6.8em'}}>
              <FormattedMessage id={'404.text'}/>
            </h4>
            <BasicButton label={''} href={appLang.path}>
              <FormattedMessage id={'404.link'}/>
            </BasicButton>
          </ContentContainer>
        </SingleColumnLayoutContentWrapper>
      </SingleColumnLayout>
    );
  }

  private _resolveAppLangFromUrl = (): any => {
    const { location: { pathname } } = this.props;

    if (pathname.match(/\/en\//) || (pathname.match(/\/en/) && pathname.length === 3)) {
      return {
        code: 'en',
        path: '/en/',
        tag: 'en-US',
      };
    } else if (pathname.match(/\/ru\//) || (pathname.match(/\/ru/) && pathname.length === 3)) {
      return {
        code: 'ru',
        path: '/ru/',
        tag: 'ru-RU',
      };
    } else {
      return {
        code: 'fi',
        path: '/',
        tag: 'fi-FI',
      };
    }
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  };
};

export default withRouter(connect(
  null,
  mapDispatchToProps
)(Page404));


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/404.tsx